import { type } from "@testing-library/user-event/dist/type";
import BmIcon from "../../../../assets/images/ic_bm.jpeg";
import DesignIcon from "../../../../assets/images/ic_design.jpeg";
import EtcIcon from "../../../../assets/images/ic_etc.jpeg";
import MarkIcon from "../../../../assets/images/ic_mark.jpeg";
import PatentIcon from "../../../../assets/images/ic_patent.jpeg";

const patentList = [
  {
    name: "elec",
    title: "전기전자",
    titleEn: "Electric/Electronic",
    icon: PatentIcon,
    typeList: ["전기소자", "전자회로", "전기통신 기술", "기타"],
    typeListEn: ["Electric Components", "Electronic Circuits", "Telecommunication Technology", "Others"],
  },
  {
    name: "machine",
    title: "기계",
    titleEn: "Machine",
    icon: PatentIcon,
    typeList: ["기관/펌프", "로봇", "조명/가열", "무기/폭파", "기타"],
    typeListEn: ["Engines/Pumps", "Robots", "Lighting/Heating", "Weapons/Explosives", "Others"],
  },
  {
    name: "chemistry",
    title: "화학",
    titleEn: "Chemistry",
    icon: PatentIcon,
    typeList: ["무기화학", "금속", "비료", "염료/페인트", "세제/왁스", "조합화학", "기타"],
    typeListEn: ["Inorganic Chemistry", "Metals", "Fertilizers", "Dyes/Paints", "Detergents/Waxes", "Composite Chemistry", "Others"],
  },
  {
    name: "physics",
    title: "물리",
    titleEn: "Physics",
    icon: PatentIcon,
    typeList: ["측정/시험", "광학", "신호/호출 시스템", "기타"],
    typeListEn: ["Measurement/Testing", "Optics", "Signal/Call Systems", "Others"],
  },
  {
    name: "it",
    title: "IT",
    titleEn: "IT",
    icon: PatentIcon,
    typeList: ["인공지능", "빅데이터", "클라우드컴퓨팅", "사물인터넷", "블록체인", "융합서비스", "기타"],
    typeListEn: ["Artificial Intelligence", "Big Data", "Cloud Computing", "Internet of Things", "Blockchain", "Converged Services", "Others"],
  },
  {
    name: "life",
    title: "생활",
    titleEn: "Life",
    icon: PatentIcon,
    typeList: ["농업", "식품", "개인/가정용품", "건강/놀이", "기타"],
    typeListEn: ["Agriculture", "Food", "Personal/Home Goods", "Health/Play", "Others"],
  },
  {
    name: "bm",
    title: "BM",
    titleEn: "Business Model",
    icon: BmIcon,
    typeList: ["중개업", "광고", "제휴", "커뮤니티", "O2O", "지식서비스", "게임", "플랫폼"],
    typeListEn: ["Brokerage", "Advertising", "Affiliation", "Community", "O2O", "Knowledge Services", "Games", "Platform"],
  },
  {
    name: "others",
    title: "기타",
    titleEn: "Others",
    icon: PatentIcon,
    typeList: [],
    typeListEn: [],
  },
];

const trademarkList = [
  {
    name: "text",
    title: "문자 상표",
    titleEn: "Text Trademark",
    icon: MarkIcon,
  },
  {
    name: "shape",
    title: "도형 상표",
  titleEn: "Shape Trademark",
    icon: DesignIcon,
  },
  {
    name: "unit",
    title: "결합 상표",
    titleEn: "Combined Trademark",
    icon: MarkIcon,
  },
  {
    name: "others",
    title: "기타",
  titleEn: "Others",
    icon: DesignIcon,
  },
];

export const categoryList = [
  {
    name: "patent",
    title: "특허/실용신안",
    titleEn: "Patent/Utility Model",
    icon: PatentIcon,
    typeList: patentList,
  },
  {
    name: "trademark",
    title: "상표",
    titleEn: "Trademark",
    icon: MarkIcon,
    typeList: trademarkList,
  },
  {
    name: "design",
    title: "디자인",
    titleEn: "Design",
    icon: DesignIcon,
    typeList: [],
  },
  {
    name: "etc",
    title: "기타",
    titleEn: "Etc",
    icon: EtcIcon,
    typeList: [],
  },
];

export const convertCodeToText = (type, depth) => {
  let result = "기타";
  if (depth === "main") {
    const item = categoryList.find((item) => item.name === type);
    result = item ? item.title : result;
  } else if (depth === "sub") {
    const item = patentList.find((item) => item.name === type);
    result = item ? item.title : result;
  }

  return result;
};
